import { createContext, useState } from 'react';
import LoadingModal from '../components/LoadingModal';

type ShowModalProps = {
  show: boolean;
};
const initialModal: ShowModalProps = {
  show: false,
};

type LoadingContext = {
  modal: ShowModalProps;
  showModal: (modalProps: ShowModalProps) => void;
};
export const LoadingModalContext = createContext<LoadingContext>({
  modal: initialModal,
  showModal: () => undefined,
});

type LoadingProviderType = {
  children: React.ReactNode;
};
const LoadingProvider: React.FC<LoadingProviderType> = ({ children }) => {
  const [modal, setModal] = useState<ShowModalProps>({ show: false });

  const showModal = (modalProps: ShowModalProps) => {
    setModal({ ...modalProps });
  };

  return (
    <LoadingModalContext.Provider value={{ modal, showModal }}>
      {children}
      <LoadingModal />
    </LoadingModalContext.Provider>
  );
};
export default LoadingProvider;
